import { Box, styled } from "@mui/material";

export const LegendContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  overflow: "hidden",
  minWidth: 212,
  maxHeight: "100%",
}));

export const LegendHeader = styled(Box)(({ theme }) => ({
  "& > div": {
    height: "auto",
    minHeight: 32,
    padding: theme.spacing(0.75, 1),
  },
}));

export const LegendInner = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(1),
  height: "100%",
  overflowY: "auto",
  paddingLeft: 2,
  paddingRight: 4,
  "& .rct-tree-item-button-GROUP": {
    backgroundColor: "#F5F5F5",
    "&.rct-tree-item-button-selected": {
      backgroundColor: "var(--rct-color-focustree-item-selected-bg)",
    },
  },
}));
